import {InjectionToken} from '@angular/core'
import {ActionEmbeddedService} from '@service/actions/action.embedded.service'
import {ActionService} from '@service/actions/action.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `ActionService`.
 *
 * @description
 * Devuelve `ActionEmbeddedService` cuando la app corre embebida y
 * `ActionService` en modo standalone. `ActionService` encapsula las
 * acciones ejecutables desde la UI (tareas, visitas, notificaciones, etc.)
 * y sus reglas de disponibilidad.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `ActionService`.
 */
export function providerActionsServiceFactory(embeddedClientService: EmbeddedClientService) {
  if (embeddedClientService.isEmbeddedFunction()) {
    return new ActionEmbeddedService()
  }
  return new ActionService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `ActionService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerActionsServiceFactory}. El alias `useExisting` permite a
 * los consumidores inyectar `ActionService` directamente.
 */
export const ActionServiceToken = new InjectionToken<ActionService>('ActionService')
